<mat-card appearance="outlined" class="contact-card">
  <mat-card-header>
    <mat-card-title>Lista de Expedientes</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngFor="let expediente of expedientes" class="contact-item">
      <div class="summary-row">
        <span>Caratula: {{ expediente.caratula |titlecase }} ({{expediente.identificadorUnico}})</span>

        <div class="icon-buttons-right">
          <button mat-icon-button color="primary" [mat-dialog-close] [routerLink]="['/expedientes/', expediente.id]" matTooltip="Ver expediente">
            <mat-icon>info</mat-icon>

          </button>
          <button mat-icon-button (click)="expediente.expanded = !expediente.expanded">
            <mat-icon>{{ expediente.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="expediente.expanded" class="detail-row">
        <div class="property-row">
          <span class="property-name">Numero:</span>
          <span class="property-value"> {{ expediente.numero }}</span>
        </div>
        <div class="property-row">
          <span class="property-name">Estado:</span>
          <span class="property-value"> {{  expediente.estadoExpediente?.descripcion | titlecase }}</span>
        </div>
        <div class="property-row">
          <span class="property-name">Juzgado:</span>
          <span class="property-value"> {{ expediente.juzgado?.descripcion | titlecase }}</span>
        </div>
        <div class="property-row">
          <span class="property-name">Tipo Expediente:</span>
          <span class="property-value"> {{ expediente.tipoExpediente?.descripcion | titlecase }}</span>
        </div>
        <div class="property-row">
          <span class="property-name">Asignado A:</span>
          <span class="property-value"> {{ expediente.asignadoA?.nombre | titlecase }} {{ expediente.asignadoA?.apellido | titlecase }}</span>
        </div>
      </div>
    </div>
    <div *ngIf="expedientes?.length == 0">
       <app-sin-datos-para-mostrar [dataSource]="null"></app-sin-datos-para-mostrar>
    </div>
  </mat-card-content>
</mat-card>
